var standalone = false;

function multifield($pluginModeElem, options) {

    var target = (options && options.selector) ? options.selector : "[data-component='multifield']";
    var component = {
        
        //Selectors
        target: target,
        rail: '.multifield-rail',
        dynamicFields: '.multifield-dynamic-field',
        button: '.multifield-action-add',
        removeButton: '.multifield-action-remove',
        visibleGroup: '.checkable-group',
        visibleGroupMarker: '.checkable-group [data-show]',
        formGroup:'.form-group',
        feedbackGroup:'.feedback-group',
        genInputName: function (name, id) {
            return [name, id].join("-");
        },
        //defaults
        config: {
            initial: 1,
            type: "text",
            label: "email",
            defaults: "",
            name: "text",
            nameRaw: "text"
        },
        // Template for dynamic fields
        fieldTemplate: function (config) {
            var template = [
                '<li id="input-' + config.type + '-' + config.id + '">',
                    '<div class="feedback-group">',
                        '<div class="form-group form-group-compact">',
                            '<div>',
                                '<input data-validation-name="' + config.nameRaw + '" data-name="' + config.name + '" novalidate type="' + config.type + '"  class="form-control multifield-dynamic-field" id="teamEmail' + config.id + '"/>',
                            '<label for="teamEmail' + config.id + '">' + config.label || config.type + '</label>',
                            '</div>',
                            config.removeBtn ? '<a href="#" title="Remove item" class="close multifield-action-remove" id="removeTeamEmail' + config.id + 'Button"> <span aria-hidden="true" class="glyphicon glyphicon-plus"></span> </a>' : '',
                        '</div>',
                        '<div id="context-message-wrap-' + config.type + '-' + config.id + '" class="context-message-wrap">',
                        '</div>',
                    '</div>',
                '</li>'
            ].join('');
            return template;
        },
        // Actions
        addField: function () {
            var self = this;
            var rail = $(self.target + ' ' + self.rail);
            var existing = rail.children("li").length;
            var populationCap = 30;

            var template = {
                type: self.config.type,
                label: self.config.label,
                initial: 1,
                id: existing,
                get name() {
                    return self.config.name + "[]";
                },
                get nameRaw() {
                    return self.config.name;
                },
                get removeBtn() {
                    //conditionally apply remove button if the id is > 0
                    return this.id === 0 ? false : true;
                }
            }

            if (existing < populationCap) {
                rail.append(self.fieldTemplate(template));
                //focus on new input
                $("[data-name='" + template.name + "']").focus();
            }
        },
        removeField: function () {
            var remaining = $(this).closest(".multifield-rail").children("li").length;

            //cap the delete so that only the first always exists
            if (remaining > 1) {
                $(this).closest("li").prev().find("input").focus();
                $(this).closest("li").remove();
            }
            
        },
        batchValidate: function () {
            //bound to jquery element in loop
            if ($(this).val() !== "") {
                $(this).addClass("filled");
                $(this).attr("name", $(this).data().name);
            }
            else {
                $(this).removeClass("filled");
                $(this).removeAttr("name");
            }
        },
        // Init
        initialize: function (config) {
            //can't use getters doesn't play well with jQuery as plugin
            var self = this;
            var dynamicFields = $(self.target + ' ' + self.dynamicFields);
            var button = $(self.target + ' ' + self.button);
            var visibleGroup = $(self.visibleGroup);
            var visibleGroupMarker = $(self.visibleGroupMarker);

            // Helpers
            function overide(prop) {
                if (config.hasOwnProperty(prop) && config[prop] !== null) self.config[prop] = config[prop];
            }

            // Allowable overide config
            overide("type");
            overide("initial");
            overide("label");
            overide("name");
            overide("defaults");

            var initial = 1;
            var targetInitialData = $(self.target).data("initial");
            if (targetInitialData !== "undefined") {
                initial = parseInt(targetInitialData);
            }

            // Actions
            //Actions: populate
            for (i = 0; i < initial; i++) {
                var id = dynamicFields.length || 0;
                this.addField(id);
            }
            //Actions: onclick
            button.on('click', function () {
                self.addField();
            });
            //Actions: remove click
            $(document).on('click', self.target+' .multifield-action-remove', function (e) {
                e.preventDefault();
                self.removeField.bind(this)();
            });

            //Actions: conditional group
            if ($(visibleGroup).length > 0 && $(visibleGroupMarker).length > 0 ) {

                $(document).on("change", '.checkable-group', function (e) {
                    var state = $(this).is(":checked");
                    $(self.target+" .multifield-dynamic-field").each(function () {
                        self.batchValidate.bind(this)()
                    })
                    if (!state) $(this).removeAttr('name');
                })

                $(document).on("focusout", self.target + " .multifield-dynamic-field", function (e) {
                    $(this).parent().find(".multifield-action-remove").focus();
                });

                $(document).on("keyup keydown", self.target + " .multifield-dynamic-field", function (e) {

                    //a data-name is present on this element, if the element is filled this becomes a fully qualified name and will submit.
                    //else it is remove again
                    //no empties allowed
                    self.batchValidate.bind(this)();
                });
            }
        }
    }

    //How jquery initializes
    if ($pluginModeElem && options) {
        if (document.readyState === 'complete') {
            component.initialize(options);
        } else {
            $(window).on('load', function() {
                component.initialize(options);
            });
        }
    }
    //how standalone initalizes
    return component;
}


if (standalone) {
    //example
    $(function () {
        multifield().initialize({
            type: 'text',
            label: '',
            initial: 1,
            name:'text[]'
        })
    })
}

//Use as a plugin
(function ($, multifield) {
    $.fn.multifield = function (options) {
        var self = this;
        //do not initialize here
        multifield(self, options);
    }
}(jQuery, multifield));
